import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Button, Popconfirm } from 'antd';
import Icon from '../../../../components/common/Icon';
const StyledLayerItem = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px 5px 1px 8px;
  font-size: 13px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border-radius: 10px;
  background-color: #ffffff;
  color: ${({ theme }) => theme.colors.gray600};
  font-weight: ${({ selected, theme }) => (selected ? 500 : 400)};
  border: 2px solid ${({ selected, theme }) => (selected ? theme.colors.primary : 'transparent')};

  &:hover {
    background-color: hsla(0, 0%, 0%, 0.07);
  }
`;
const LayerName = styled.span `
  color: #262626;
  flex: 1;
  text-align: start;
  line-height: 32px;
`;
const VisibilityButton = styled(Button) `
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border: none;
    box-shadow: none;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`;
export const LayerItem = ({ name, visible, onToggleVisibility, selected = true, onClick, deleteLayer, }) => {
    const confirm = async () => {
        try {
            deleteLayer(name);
        }
        catch (error) {
        }
    };
    const cancel = (e) => {
    };
    return (_jsxs(StyledLayerItem, { selected: selected, children: [_jsx(LayerName, { onClick: onClick, children: name }), _jsx(VisibilityButton, { type: "text", onClick: () => onToggleVisibility(name), icon: visible ? _jsx(Icon, { icon: "eye", size: 16 }) : _jsx(Icon, { icon: "eye-off", size: 16 }) }), !(name === 'Route Layer' || name === 'Outer Wall') && (_jsx(Popconfirm, { title: "Delete the task", description: "Are you sure to delete this layer?", onConfirm: confirm, onCancel: cancel, okText: "Yes", cancelText: "No", children: _jsx(Button, { type: "text", icon: _jsx(Icon, { icon: "trash-03", size: 16 }) }) }))] }));
};
